export default __webpack_public_path__ + "static/media/BuckeyeSmooth-Scarlet.c1afd85a.svg";